import { ENDPOINTS } from 'src/constants/endpoints'

import { HANWHA_ORG_ID } from 'src/app/auth/constants/organization'
import type { IWhyWeInvestResponseDTO } from 'src/app/home/pages/why-we-invest/domain/contracts/why-we-invest'
import { http } from 'src/interfaces/http'

export const getWhyWeInvest = async (): Promise<IWhyWeInvestResponseDTO> => {
  const { data } = await http.get<IWhyWeInvestResponseDTO>(
    ENDPOINTS.hanwha.whyWeInvest,
    { params: { org_id: HANWHA_ORG_ID } },
  )

  return data
}
